export const FACTS: string[] = [
  '13 dancers',
  '16 scenes',
  'Non-verbal',
  'Video mapping',
  'Volumetric light',
  'Real-time generative visuals',
]
